import ReportService from "@/services/reports/report.service";

export const reports = {
    namespaced: true,
    state: { list:[], rangeList: [], alerts: [], employees: [], userActions: [], template: null },
    actions:{
        getTemperatureReports({ commit }, filterData){
            return ReportService.getTemperatureReports(filterData)
                .then(
                    reports => {
                        commit('temperatureReportFetchSuccess', reports)
                    },
                    error => {
                        commit('fetchingFail',error)
                    }
                )
        },
        TemperatureReportsExport({ commit }, filterData){
            return ReportService.TemperatureReportsExport(filterData)
                .then(
                    reports => {
                        commit('temperatureReportExportSuccess', reports)
                    },
                    error => {
                        commit('fetchingFail',error)
                    }
                )
        },
        getTemperatureAlertReportsExport({ commit }, filterData){
            return ReportService.getTemperatureAlertReportsExport(filterData)
                .then(
                    reports => {
                        commit('temperatureReportExportSuccess', reports)
                    },
                    error => {
                        commit('fetchingFail',error)
                    }
                )
        },
        TemperatureRangeReportsExport({ commit }, filterData){
            return ReportService.TemperatureRangeReportsExport(filterData)
                .then(
                    reports => {
                        commit('TemperatureRangeReportsExportSuccess', reports)
                    },
                    error => {
                        commit('fetchingFail',error)
                    }
                )
        },
        getTemperatureRangeReports({ commit }, filterData){
            return ReportService.getTemperatureRangeReport(filterData)
                .then(
                    reports => {
                        commit('temperatureRangeReportFetchSuccess', reports)
                    },
                    error => {
                        commit('fetchingFail', error)
                    }
                )
        },
        getTemperatureRangeReportTemplate({ commit }){
            return ReportService.getTemperatureRangeReportTemplate()
                .then(
                    template => {
                        commit('fetchTemplateSuccess',template)
                    },
                    error => {
                        commit('fetchingFail', error)
                    }
                )
        },
        getTemperatureAlertReports({ commit }, filterData){
            return ReportService.getAlertReport(filterData).then(
                alerts => {
                    commit('fetchAlertReports', alerts)
                },
                error => {
                    commit('fetchingFail', error)
                }
            )
        },
        getEmployees({ commit }){
          return ReportService.getEmployees().then(
              employees => {
                  commit('fetchEmployees', employees)
              },
              error => {
                  commit('fetchingFail', error)
              }
          )
        },
        getUserActionReports({ commit }, filterData){
            return ReportService.getUserActionReport(filterData).then(
                userActions => {
                    commit('fetchUserActionReports', userActions)
                },
                error => {
                    commit('fetchingFail', error)
                }
            )
        }
    },
    mutations:{
        temperatureReportFetchSuccess(state, reports){
            state.list = reports.data.list
        },
        temperatureReportExportSuccess(state, reports){
            const href = URL.createObjectURL(reports.data);

            // create "a" HTML element with href to file & click
            const link = document.createElement('a');
            link.href = href;

            link.setAttribute('download', 'report: ' + reports.config.params.dateRange + '.xlsx'); //or any other extension
            document.body.appendChild(link);
            link.click();

            // clean up "a" element & remove ObjectURL
            document.body.removeChild(link);
            URL.revokeObjectURL(href);
        },
        TemperatureRangeReportsExportSuccess(state, reports){
            const href = URL.createObjectURL(reports.data);

            // create "a" HTML element with href to file & click
            const link = document.createElement('a');
            link.href = href;

            link.setAttribute('download', 'report: ' + reports.config.params.dateRange + '.xlsx'); //or any other extension
            document.body.appendChild(link);
            link.click();

            // clean up "a" element & remove ObjectURL
            document.body.removeChild(link);
            URL.revokeObjectURL(href);
        },
        temperatureRangeReportFetchSuccess(state, reports){
            state.rangeList = reports
        },
        fetchTemplateSuccess(state, template){
            state.template = template
        },
        fetchAlertReports(state, alerts){
            state.alerts = alerts
        },
        fetchEmployees(state, employees){
            state.employees = employees
        },
        fetchUserActionReports(state, userActions){
            state.userActions = userActions
        },
        fetchingFail(state, error){
            state.error = error
        }
    }
}